<template>
	<div class="news-form-container">
		<!-- 页面头部 -->
		<div class="page-header">
			<div class="header-content">
				<div class="header-left">
					<div class="back-button" @click="back()">
						<i class="el-icon-arrow-left"></i>
					</div>
					<div class="header-info">
						<h1 class="page-title">
							{{ type === 'info' ? '新闻详情' : (ruleForm.id ? '编辑新闻' : '发布新闻') }}
						</h1>
						<div class="breadcrumb">
							<span class="breadcrumb-item">新闻资讯管理</span>
							<i class="el-icon-arrow-right"></i>
							<span class="breadcrumb-current">
								{{ type === 'info' ? '查看详情' : (ruleForm.id ? '编辑新闻' : '发布新闻') }}
							</span>
						</div>
					</div>
				</div>
				<div class="header-actions" v-if="type !== 'info'">
					<el-button @click="back()" class="cancel-btn">
						<i class="el-icon-close"></i>
						取消
					</el-button>
					<el-button type="primary" @click="onSubmit" :loading="submitLoading" class="submit-btn">
						<i class="el-icon-check"></i>
						{{ submitLoading ? '发布中...' : '发布新闻' }}
					</el-button>
				</div>
				<div class="header-actions" v-else>
					<el-button @click="back()" class="back-btn">
						<i class="el-icon-back"></i>
						返回列表
					</el-button>
				</div>
			</div>
		</div>

		<!-- 表单内容 -->
		<div class="form-content">
			<el-form
				ref="ruleForm"
				:model="ruleForm"
				:rules="rules"
				label-width="120px"
				class="news-form"
			>
				<!-- 基本信息 -->
				<div class="form-section">
					<h3 class="section-title">基本信息</h3>
					
					<!-- 新闻标题 -->
					<el-form-item label="新闻标题" prop="title" class="form-item">
						<div class="input-wrapper">
							<div class="input-field">
								<svg class="field-icon" viewBox="0 0 24 24">
									<path d="M20,11H4V8H20M20,15H13V13H20M20,19H13V17H20M11,19H4V13H11M20.33,4.67L18.67,3L17,4.67L15.33,3L13.67,4.67L12,3L10.33,4.67L8.67,3L7,4.67L5.33,3L3.67,4.67L2,3V19A2,2 0 0,0 4,21H20A2,2 0 0,0 22,19V3L20.33,4.67Z"/>
								</svg>
								<el-input 
									v-if="type !== 'info'" 
									v-model="ruleForm.title" 
									placeholder="请输入新闻标题" 
									clearable
									:readonly="ro.title"
									class="form-input"
								></el-input>
								<el-input 
									v-else 
									v-model="ruleForm.title" 
									placeholder="新闻标题" 
									readonly
									class="form-input"
								></el-input>
							</div>
							<span class="field-tip">新闻标题应该简洁明了，便于读者理解</span>
						</div>
					</el-form-item>

					<!-- 新闻简介 -->
					<el-form-item label="新闻简介" prop="introduction" class="form-item textarea-item">
						<div class="textarea-wrapper" v-if="type !== 'info'">
							<el-input
								type="textarea"
								:rows="4"
								placeholder="请输入新闻简介，简要概述新闻内容"
								v-model="ruleForm.introduction"
								class="form-textarea"
								maxlength="500"
								show-word-limit
							></el-input>
							<span class="field-tip">新闻简介将在列表页展示，建议控制在100字以内</span>
						</div>
						<div class="preview-content" v-else-if="ruleForm.introduction">
							<div class="content-text">{{ ruleForm.introduction }}</div>
						</div>
						<div class="empty-content" v-else>
							<span>暂无简介内容</span>
						</div>
					</el-form-item>
				</div>

				<!-- 图片设置 -->
				<div class="form-section">
					<h3 class="section-title">图片设置</h3>
					
					<!-- 新闻图片 -->
					<el-form-item label="新闻图片" prop="picture" class="form-item image-item">
						<div class="image-upload-wrapper" v-if="type !== 'info' && !ro.picture">
							<div class="upload-area">
								<file-upload
									tip="点击上传新闻图片"
									action="file/upload"
									:limit="3"
									:multiple="true"
									:fileUrls="ruleForm.picture ? ruleForm.picture : ''"
									@change="pictureUploadChange"
									class="image-uploader"
								></file-upload>
							</div>
							<div class="upload-tips">
								<h4>图片要求：</h4>
								<ul>
									<li>支持格式：JPG、PNG、GIF</li>
									<li>图片大小：不超过5MB</li>
									<li>建议尺寸：800×600像素</li>
									<li>可上传多张图片作为新闻配图</li>
								</ul>
							</div>
						</div>
						<div class="image-preview" v-else-if="ruleForm.picture">
							<div class="preview-header">
								<h4>新闻图片</h4>
							</div>
							<div class="image-gallery">
								<div class="preview-item" v-if="ruleForm.picture.substring(0,4)==='http'" :key="'http-image'">
									<img class="preview-img" :src="ruleForm.picture.split(',')[0]" />
									<div class="image-actions">
										<el-button 
											size="mini" 
											icon="el-icon-zoom-in" 
											@click="previewImage(ruleForm.picture.split(',')[0])"
										>
											预览
										</el-button>
									</div>
								</div>
								<div 
									v-else
									v-for="(item,index) in ruleForm.picture.split(',')" 
									:key="'local-image-' + index" 
									class="preview-item"
								>
									<img class="preview-img" :src="$base.url+item" />
									<div class="image-actions">
										<el-button 
											size="mini" 
											icon="el-icon-zoom-in" 
											@click="previewImage($base.url+item)"
										>
											预览
										</el-button>
									</div>
								</div>
							</div>
						</div>
						<div class="empty-image" v-else>
							<i class="el-icon-picture-outline"></i>
							<p>暂未上传新闻图片</p>
							<span>新闻图片有助于提升内容吸引力</span>
						</div>
					</el-form-item>
				</div>

				<!-- 内容编辑 -->
				<div class="form-section">
					<h3 class="section-title">详细内容</h3>
					
					<!-- 新闻内容 -->
					<el-form-item label="新闻内容" prop="content" class="form-item content-item">
						<div class="editor-wrapper" v-if="type !== 'info'">
							<editor 
								v-model="ruleForm.content" 
								class="content-editor" 
								action="file/upload"
								placeholder="请输入新闻详细内容..."
							></editor>
							<span class="field-tip">支持富文本编辑，可插入图片、表格等多媒体内容</span>
						</div>
						<div class="content-preview" v-else-if="ruleForm.content">
							<div class="preview-header">
								<h4>新闻详细内容</h4>
							</div>
							<div class="content-html" v-html="ruleForm.content"></div>
						</div>
						<div class="empty-content" v-else>
							<i class="el-icon-document"></i>
							<p>暂无详细内容</p>
						</div>
					</el-form-item>
				</div>
			</el-form>
		</div>

		<!-- 图片预览对话框 -->
		<el-dialog
			:visible.sync="previewVisible"
			title="图片预览"
			width="60%"
			class="preview-dialog"
		>
			<div class="image-preview-container">
				<img :src="previewImageUrl" class="preview-image" />
			</div>
		</el-dialog>
	</div>
</template>
<script>
// 数字，邮件，手机，url，身份证校验
import { isNumber,isIntNumer,isEmail,isPhone, isMobile,isURL,checkIdCard } from "@/utils/validate";
export default {
	data() {
		let self = this
		var validateIdCard = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!checkIdCard(value)) {
				callback(new Error("请输入正确的身份证号码"));
			} else {
				callback();
			}
		};
		var validateUrl = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isURL(value)) {
				callback(new Error("请输入正确的URL地址"));
			} else {
				callback();
			}
		};
		var validateMobile = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isMobile(value)) {
				callback(new Error("请输入正确的手机号码"));
			} else {
				callback();
			}
		};
		var validatePhone = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isPhone(value)) {
				callback(new Error("请输入正确的电话号码"));
			} else {
				callback();
			}
		};
		var validateEmail = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isEmail(value)) {
				callback(new Error("请输入正确的邮箱地址"));
			} else {
				callback();
			}
		};
		var validateNumber = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isNumber(value)) {
				callback(new Error("请输入数字"));
			} else {
				callback();
			}
		};
		var validateIntNumber = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isIntNumer(value)) {
				callback(new Error("请输入整数"));
			} else {
				callback();
			}
		};
		return {
			id: '',
			type: '',
			submitLoading: false, // 提交加载状态
			previewVisible: false, // 图片预览对话框显示状态
			previewImageUrl: '', // 预览图片地址
			
			ro:{
				title : false,
				introduction : false,
				picture : false,
				content : false,
			},
			
			
			ruleForm: {
				title: '',
				introduction: '',
				picture: '',
				content: '',
			},
		
			
			rules: {
				title: [
					{ required: true, message: '标题不能为空', trigger: 'blur' },
				],
				introduction: [
				],
				picture: [
					{ required: true, message: '图片不能为空', trigger: 'blur' },
				],
				content: [
					{ required: true, message: '内容不能为空', trigger: 'blur' },
				],
			}
		};
	},
	props: ["parent"],
	computed: {



	},
	created() {
	},
	methods: {
		
		// 下载
		download(file){
			window.open(`${file}`)
		},
		// 初始化
		init(id,type) {
			if (id) {
				this.id = id;
				this.type = type;
			}
			if(this.type=='info'||this.type=='else'){
				this.info(id);
			}else if(this.type=='logistics'){
				this.logistics=false;
				this.info(id);
			}else if(this.type=='cross'){
				var obj = this.$storage.getObj('crossObj');
				for (var o in obj){
						if(o=='title'){
							this.ruleForm.title = obj[o];
							this.ro.title = true;
							continue;
						}
						if(o=='introduction'){
							this.ruleForm.introduction = obj[o];
							this.ro.introduction = true;
							continue;
						}
						if(o=='picture'){
							this.ruleForm.picture = obj[o];
							this.ro.picture = true;
							continue;
						}
						if(o=='content'){
							this.ruleForm.content = obj[o];
							this.ro.content = true;
							continue;
						}
				}
				




			}
			
			
			
			
		},
    // 多级联动参数

    info(id) {
      this.$http({
        url: `news/info/${id}`,
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0) {
        this.ruleForm = data.data;
        //解决前台上传图片后台不显示的问题
        let reg=new RegExp('../../../upload','g')//g代表全部
        				this.ruleForm.content = this.ruleForm.content.replace(reg,'http://ht.yiminkangjian.top/taoziyiyuan/upload');
        } else {
          this.$message.error(data.msg);
        }
      });
    },


    // 提交
    onSubmit() {






	if(this.ruleForm.picture!=null) {
		this.ruleForm.picture = this.ruleForm.picture.replace(new RegExp(this.$base.url,"g"),"");
	}



var objcross = this.$storage.getObj('crossObj');

      //更新跨表属性
       var crossuserid;
       var crossrefid;
       var crossoptnum;
       if(this.type=='cross'){
                var statusColumnName = this.$storage.get('statusColumnName');
                var statusColumnValue = this.$storage.get('statusColumnValue');
                if(statusColumnName!='') {
                        var obj = this.$storage.getObj('crossObj');
                       if(statusColumnName && !statusColumnName.startsWith("[")) {
                               for (var o in obj){
                                 if(o==statusColumnName){
                                   obj[o] = statusColumnValue;
                                 }
                               }
                               var table = this.$storage.get('crossTable');
                             this.$http({
                                 url: `${table}/update`,
                                 method: "post",
                                 data: obj
                               }).then(({ data }) => {});
                       } else {
                               crossuserid=this.$storage.get('userid');
                               crossrefid=obj['id'];
                               crossoptnum=this.$storage.get('statusColumnName');
                               crossoptnum=crossoptnum.replace(/\[/,"").replace(/\]/,"");
                        }
                }
        }
       this.submitLoading = true;

       this.$refs["ruleForm"].validate(valid => {
         if (valid) {
		 if(crossrefid && crossuserid) {
			 this.ruleForm.crossuserid = crossuserid;
			 this.ruleForm.crossrefid = crossrefid;
			let params = { 
				page: 1, 
				limit: 10, 
				crossuserid:this.ruleForm.crossuserid,
				crossrefid:this.ruleForm.crossrefid,
			} 
			this.$http({ 
				url: "news/page", 
				method: "get", 
				params: params 
			}).then(({ 
				data 
			}) => { 
				if (data && data.code === 0) { 
				       if(data.data.total>=crossoptnum) {
					     this.submitLoading = false;
					     this.$message.error(this.$storage.get('tips'));
					       return false;
				       } else {
					 this.$http({
					   url: `news/${!this.ruleForm.id ? "save" : "update"}`,
					   method: "post",
					   data: this.ruleForm
					 }).then(({ data }) => {
					   this.submitLoading = false;
					   if (data && data.code === 0) {
					     this.$message({
					       message: "操作成功",
					       type: "success",
					       duration: 1500,
					       onClose: () => {
						 this.parent.showFlag = true;
						 this.parent.addOrUpdateFlag = false;
						 this.parent.newsCrossAddOrUpdateFlag = false;
						 this.parent.search();
						 this.parent.contentStyleChange();
					       }
					     });
					   } else {
					     this.$message.error(data.msg);
					   }
					 });

				       }
				} else { 
				} 
			});
		 } else {
			 this.$http({
			   url: `news/${!this.ruleForm.id ? "save" : "update"}`,
			   method: "post",
			   data: this.ruleForm
			 }).then(({ data }) => {
			   this.submitLoading = false;
			   if (data && data.code === 0) {
			     this.$message({
			       message: "操作成功",
			       type: "success",
			       duration: 1500,
			       onClose: () => {
				 this.parent.showFlag = true;
				 this.parent.addOrUpdateFlag = false;
				 this.parent.newsCrossAddOrUpdateFlag = false;
				 this.parent.search();
				 this.parent.contentStyleChange();
			       }
			     });
			   } else {
			     this.$message.error(data.msg);
			   }
			 });
		 }
         } else {
           this.submitLoading = false;
         }
       });
    },
    // 获取uuid
    getUUID () {
      return new Date().getTime();
    },
    // 返回
    back() {
      this.parent.showFlag = true;
      this.parent.addOrUpdateFlag = false;
      this.parent.newsCrossAddOrUpdateFlag = false;
      this.parent.contentStyleChange();
    },
    pictureUploadChange(fileUrls) {
	    this.ruleForm.picture = fileUrls;
    },

    // 预览图片
    previewImage(imageUrl) {
      this.previewImageUrl = imageUrl;
      this.previewVisible = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.news-form-container {
	background: #f8fafc;
	min-height: 100vh;
	padding: 24px;
}

// 页面头部
.page-header {
	margin-bottom: 24px;
	
	.header-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: white;
		padding: 20px 24px;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

		.header-left {
			display: flex;
			align-items: center;
			gap: 16px;
			flex: 1;

			.back-button {
				width: 40px;
				height: 40px;
				background: #f8fafc;
				border: 1px solid #e2e8f0;
				border-radius: 8px;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				transition: all 0.2s ease;
				color: #64748b;

				&:hover {
					background: #f1f5f9;
					border-color: #cbd5e1;
					color: #475569;
				}

				&:active {
					background: #e2e8f0;
				}

				i {
					font-size: 16px;
				}
			}

			.header-info {
				.page-title {
					font-size: 20px;
					font-weight: 600;
					color: #1e293b;
					margin: 0 0 4px 0;
					line-height: 1.2;
				}

				.breadcrumb {
					display: flex;
					align-items: center;
					gap: 8px;
					font-size: 13px;
					color: #64748b;

					.breadcrumb-item {
						color: #64748b;
					}

					.breadcrumb-current {
						color: #f97316;
						font-weight: 500;
					}

					i {
						font-size: 12px;
						color: #94a3b8;
					}
				}
			}
		}

		.header-actions {
			display: flex;
			gap: 12px;
			align-items: center;

			.el-button {
				padding: 10px 20px;
				font-weight: 500;
				border-radius: 6px;
				font-size: 14px;
				display: flex;
				align-items: center;
				gap: 6px;

				i {
					font-size: 14px;
				}
			}

			.cancel-btn {
				color: #6b7280;
				border-color: #d1d5db;
				background: white;

				&:hover {
					color: #374151;
					border-color: #9ca3af;
					background: #f9fafb;
				}
			}

			.submit-btn {
				background: #f97316;
				border-color: #f97316;
				color: white;

				&:hover {
					background: #ea580c;
					border-color: #ea580c;
				}

				&:disabled {
					background: #d1d5db;
					border-color: #d1d5db;
					color: #9ca3af;
				}
			}

			.back-btn {
				background: #f97316;
				border-color: #f97316;
				color: white;

				&:hover {
					background: #ea580c;
					border-color: #ea580c;
				}
			}
		}
	}
}

// 表单内容
.form-content {
	background: white;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	overflow: hidden;

	.news-form {
		padding: 0;

		// 表单区块
		.form-section {
			padding: 24px;
			border-bottom: 1px solid #f1f5f9;

			&:last-child {
				border-bottom: none;
			}

			.section-title {
				font-size: 16px;
				font-weight: 600;
				color: #1e293b;
				margin: 0 0 20px 0;
				padding-bottom: 12px;
				border-bottom: 2px solid #f97316;
				display: inline-block;
			}
		}

		// 表单项
		.form-item {
			margin-bottom: 24px;

			&:last-child {
				margin-bottom: 0;
			}

			:deep(.el-form-item__label) {
				font-weight: 600;
				color: #374151;
				font-size: 14px;
				line-height: 1.5;
				padding: 0 12px 0 0;
			}

			:deep(.el-form-item__content) {
				line-height: 1.5;
			}

			// 输入框包装器
			.input-wrapper {
				.input-field {
					position: relative;
					display: flex;
					align-items: center;
					background: #f8fafc;
					border: 1px solid #e2e8f0;
					border-radius: 6px;
					transition: all 0.2s ease;

					&:focus-within {
						border-color: #f97316;
						box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
					}

					.field-icon {
						width: 16px;
						height: 16px;
						margin: 0 12px;
						fill: #f97316;
						flex-shrink: 0;
					}

					.form-input {
						flex: 1;

						:deep(.el-input__inner) {
							border: none;
							padding: 12px 0;
							font-size: 14px;
							line-height: 1.5;
							color: #374151;
							background: transparent;

							&[readonly] {
								background: transparent;
								color: #6b7280;
								cursor: not-allowed;
							}
						}
					}
				}

				.field-tip {
					display: block;
					margin-top: 6px;
					font-size: 12px;
					color: #6b7280;
					line-height: 1.4;
				}
			}

			// 文本域相关
			&.textarea-item {
				.textarea-wrapper {
					.form-textarea {
						:deep(.el-textarea__inner) {
							border: 1px solid #e2e8f0;
							border-radius: 6px;
							padding: 12px;
							font-size: 14px;
							line-height: 1.5;
							color: #374151;
							background: #f8fafc;
							transition: all 0.2s ease;

							&:focus {
								border-color: #f97316;
								box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
								background: white;
							}
						}
					}

					.field-tip {
						display: block;
						margin-top: 6px;
						font-size: 12px;
						color: #6b7280;
						line-height: 1.4;
					}
				}

				.preview-content {
					padding: 12px 16px;
					background: #f8fafc;
					border: 1px solid #e2e8f0;
					border-radius: 6px;

					.content-text {
						font-size: 14px;
						color: #374151;
						line-height: 1.6;
						white-space: pre-wrap;
					}
				}

				.empty-content {
					padding: 40px 20px;
					text-align: center;
					color: #9ca3af;
					background: #f8fafc;
					border: 2px dashed #d1d5db;
					border-radius: 6px;
				}
			}

			// 图片相关
			&.image-item {
				.image-upload-wrapper {
					display: flex;
					gap: 24px;
					align-items: flex-start;

					.upload-area {
						flex: 1;
					}

					.upload-tips {
						flex: 0 0 300px;
						background: #f8fafc;
						padding: 20px;
						border-radius: 8px;
						border: 1px solid #e2e8f0;

						h4 {
							font-size: 14px;
							font-weight: 600;
							color: #374151;
							margin: 0 0 12px 0;
						}

						ul {
							margin: 0;
							padding: 0 0 0 16px;

							li {
								font-size: 12px;
								color: #6b7280;
								line-height: 1.6;
								margin-bottom: 4px;

								&:last-child {
									margin-bottom: 0;
								}
							}
						}
					}
				}

				.image-preview {
					.preview-header {
						margin-bottom: 16px;

						h4 {
							font-size: 14px;
							font-weight: 600;
							color: #374151;
							margin: 0;
						}
					}

					.image-gallery {
						display: flex;
						gap: 16px;
						flex-wrap: wrap;

						.preview-item {
							position: relative;
							display: flex;
							flex-direction: column;
							align-items: center;
							padding: 12px;
							background: #f8fafc;
							border: 1px solid #e2e8f0;
							border-radius: 8px;

							.preview-img {
								width: 120px;
								height: 120px;
								object-fit: cover;
								border-radius: 6px;
								border: 1px solid #d1d5db;
								margin-bottom: 8px;
							}

							.image-actions {
								.el-button {
									font-size: 11px;
									padding: 4px 8px;
								}
							}
						}
					}
				}

				.empty-image {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					padding: 40px 20px;
					background: #f8fafc;
					border: 2px dashed #d1d5db;
					border-radius: 8px;
					color: #9ca3af;
					text-align: center;

					i {
						font-size: 48px;
						margin-bottom: 12px;
						color: #d1d5db;
					}

					p {
						font-size: 14px;
						color: #6b7280;
						margin: 0 0 8px 0;
						font-weight: 500;
					}

					span {
						font-size: 12px;
						color: #9ca3af;
						line-height: 1.4;
					}
				}
			}

			// 内容编辑相关
			&.content-item {
				.editor-wrapper {
					.content-editor {
						border: 1px solid #e2e8f0;
						border-radius: 6px;
						overflow: hidden;

						:deep(.w-e-text-container) {
							background: #f8fafc;
							
							.w-e-text {
								background: white;
								min-height: 300px;
								padding: 16px;
								line-height: 1.6;
							}
						}

						:deep(.w-e-toolbar) {
							background: #f8fafc;
							border-bottom: 1px solid #e2e8f0;
						}
					}

					.field-tip {
						display: block;
						margin-top: 6px;
						font-size: 12px;
						color: #6b7280;
						line-height: 1.4;
					}
				}

				.content-preview {
					.preview-header {
						margin-bottom: 16px;
						padding-bottom: 12px;
						border-bottom: 1px solid #e2e8f0;

						h4 {
							font-size: 14px;
							font-weight: 600;
							color: #374151;
							margin: 0;
						}
					}

					.content-html {
						padding: 16px;
						background: #f8fafc;
						border: 1px solid #e2e8f0;
						border-radius: 6px;
						line-height: 1.6;
						color: #374151;

						:deep(img) {
							max-width: 100%;
							height: auto;
							border-radius: 4px;
							margin: 8px 0;
						}

						:deep(p) {
							margin: 12px 0;
						}

						:deep(h1, h2, h3, h4, h5, h6) {
							margin: 16px 0 8px 0;
							color: #1e293b;
						}

						:deep(blockquote) {
							margin: 16px 0;
							padding: 12px 16px;
							background: #f1f5f9;
							border-left: 4px solid #f97316;
							border-radius: 4px;
						}

						:deep(ul, ol) {
							margin: 12px 0;
							padding-left: 24px;
						}

						:deep(table) {
							width: 100%;
							border-collapse: collapse;
							margin: 16px 0;

							th, td {
								border: 1px solid #e2e8f0;
								padding: 8px 12px;
								text-align: left;
							}

							th {
								background: #f8fafc;
								font-weight: 600;
							}
						}
					}
				}

				.empty-content {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					padding: 40px 20px;
					background: #f8fafc;
					border: 2px dashed #d1d5db;
					border-radius: 8px;
					color: #9ca3af;
					text-align: center;

					i {
						font-size: 48px;
						margin-bottom: 12px;
						color: #d1d5db;
					}

					p {
						font-size: 14px;
						color: #6b7280;
						margin: 0;
						font-weight: 500;
					}
				}
			}
		}

		// 错误状态
		:deep(.el-form-item.is-error) {
			.input-field {
				border-color: #ef4444;

				&:focus-within {
					border-color: #ef4444;
					box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
				}
			}

			.form-textarea {
				:deep(.el-textarea__inner) {
					border-color: #ef4444;

					&:focus {
						border-color: #ef4444;
						box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
					}
				}
			}
		}

		// 必填标识
		:deep(.el-form-item.is-required) {
			.el-form-item__label::before {
				content: '*';
				color: #ef4444;
				margin-right: 4px;
			}
		}
	}
}

// 图片预览对话框
.preview-dialog {
	:deep(.el-dialog) {
		border-radius: 8px;
	}

	:deep(.el-dialog__header) {
		background: #f8fafc;
		border-bottom: 1px solid #e5e7eb;
		padding: 16px 24px;

		.el-dialog__title {
			font-weight: 600;
			color: #1e293b;
		}
	}

	:deep(.el-dialog__body) {
		padding: 24px;
	}

	.image-preview-container {
		text-align: center;

		.preview-image {
			max-width: 100%;
			max-height: 500px;
			border-radius: 8px;
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		}
	}
}

// 响应式设计
@media (max-width: 1024px) {
	.news-form-container {
		padding: 20px;
	}

	.form-content {
		.news-form {
			.form-section {
				padding: 20px;
			}

			.form-item {
				&.image-item {
					.image-upload-wrapper {
						flex-direction: column;
						gap: 16px;

						.upload-tips {
							flex: 1;
						}
					}
				}
			}
		}
	}
}

@media (max-width: 768px) {
	.news-form-container {
		padding: 16px;
	}

	.page-header {
		.header-content {
			flex-direction: column;
			gap: 16px;
			align-items: stretch;

			.header-left {
				justify-content: flex-start;
			}

			.header-actions {
				justify-content: center;
				order: -1;

				.el-button {
					flex: 1;
					max-width: 120px;
				}
			}
		}
	}

	.form-content {
		.news-form {
			:deep(.el-form-item__label) {
				text-align: left;
				float: none;
				display: block;
				width: 100% !important;
				margin-bottom: 8px;
				padding: 0;
			}

			:deep(.el-form-item__content) {
				margin-left: 0 !important;
			}

			.form-section {
				padding: 16px;
			}
		}
	}
}

@media (max-width: 480px) {
	.news-form-container {
		padding: 12px;
	}

	.page-header {
		.header-content {
			padding: 16px;

			.header-left {
				.back-button {
					width: 36px;
					height: 36px;

					i {
						font-size: 14px;
					}
				}

				.header-info {
					.page-title {
						font-size: 18px;
					}

					.breadcrumb {
						font-size: 12px;
					}
				}
			}

			.header-actions {
				.el-button {
					padding: 8px 16px;
					font-size: 13px;

					i {
						font-size: 13px;
					}
				}
			}
		}
	}

	.form-content {
		.news-form {
			.form-section {
				padding: 12px;

				.section-title {
					font-size: 15px;
					margin-bottom: 16px;
				}
			}

			.form-item {
				margin-bottom: 20px;

				.input-wrapper {
					.input-field {
						.field-icon {
							width: 14px;
							height: 14px;
							margin: 0 10px;
						}

						.form-input {
							:deep(.el-input__inner) {
								padding: 10px 0;
								font-size: 14px;
							}
						}
					}

					.field-tip {
						font-size: 11px;
					}
				}

				&.textarea-item {
					.textarea-wrapper {
						.field-tip {
							font-size: 11px;
						}
					}
				}

				&.image-item {
					.image-preview {
						.image-gallery {
							.preview-item {
								.preview-img {
									width: 80px;
									height: 80px;
								}
							}
						}
					}

					.empty-image {
						padding: 30px 16px;

						i {
							font-size: 36px;
						}

						p {
							font-size: 13px;
						}

						span {
							font-size: 11px;
						}
					}
				}

				&.content-item {
					.editor-wrapper {
						.field-tip {
							font-size: 11px;
						}
					}

					.empty-content {
						padding: 30px 16px;

						i {
							font-size: 36px;
						}

						p {
							font-size: 13px;
						}
					}
				}
			}
		}
	}

	.preview-dialog {
		:deep(.el-dialog) {
			width: 90% !important;
			margin: 20px;
		}

		:deep(.el-dialog__body) {
			padding: 16px;
		}
	}
}
</style>
